<template>
    <div class="form-field form-field__bool form-field__checkbox" :class="rootClasses">
        <div class="form-field--row">
            <div class="form-field--input-container">
                <input type="checkbox"
                        class="form-field--input"
                        v-bind="getInputAttrs(item)"
                        v-model="model"
                        :value="item.val">
                <label class="form-field--label-wrap" :for="item.id">
                    <span class="form-field--box">
                        <base-icon class="form-field--box-icon" symbol="checkmark" size="small"/>
                    </span>
                    <span class="form-field--label" v-html="label"/>
                </label>
            </div>
        </div>
        <form-field-messages :messages="messages"/>
    </div>
</template>

<script>
    import FormFieldMessages from 'framework/components/form//form-field-messages/form-field-messages';
    import formFieldAbstractMixin from 'framework/mixins/form/form-field-abstract';
    import formFieldBoolMixin from 'framework/mixins/form/form-field-bool';


    export default {
        components: {
            FormFieldMessages,
        },
        mixins: [
            formFieldAbstractMixin,
            formFieldBoolMixin,
        ],
        inheritAttrs: false,
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            /** @type {IFormFieldState} */
            state: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        computed: {
            item() {
                return {
                    val: this.id,
                    name: this.id,
                    id: this.id,
                    label: this.label,
                };
            },
            specificRootClasses() {
                return [
                    this.bemAdd('vertical'),
                    this.bemAdd('multiline'),
                ];
            },
        },
    };
</script>
